/* src/app/addons/notification/notification-list.component.css */
.notification-list {
  max-height: 50vh;
  overflow-y: auto;
}
.notification-item {
  cursor: pointer;
  transition: background-color 0.2s;
}
.notification-item:hover {
  background-color: var(--surface-hover);
}
.notification-item.unread {
  background-color: var(--primary-50);
}
.notification-item.unread:hover {
  background-color: var(--primary-100);
}
.text-success {
  color: var(--green-500);
}
.text-info {
  color: var(--blue-500);
}
.text-warn {
  color: var(--yellow-500);
}
.text-error {
  color: var(--red-500);
}
/*# sourceMappingURL=notification-list.component-JBDWJ2BR.css.map */
